import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state(){
        return {
            methode: null,
            methoden: null,
        }
    },
    mutations: {
        setMethode(state,methode){
            state.methode = methode
        },
        setMethoden(state,methoden){
            state.methoden = methoden
        }
    },
    actions:{
        fetchMethode({commit},id){
            axiosInstance.get('/zon/methode/' + id)
                .then(result => commit('setMethode',result.data))
        },
        fetchMethoden({commit}){
            axiosInstance.get('/zon/methode')
                .then(result => commit('setMethoden',result.data))
        }

    },
    getters:{},

}
